import { render } from "./JumpLink.vue?vue&type=template&id=6a025898&scoped=true"
import script from "./JumpLink.vue?vue&type=script&lang=js"
export * from "./JumpLink.vue?vue&type=script&lang=js"

import "./JumpLink.vue?vue&type=style&index=0&id=6a025898&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a025898"]])

export default __exports__